/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Admin_External_Booking_Edit_Order_Summary_Discount_LineInputs */

const en_admin_external_booking_edit_order_summary_discount_line = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Discount_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Discount (${i?.code})`)
};

const de_admin_external_booking_edit_order_summary_discount_line = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Discount_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rabatt (${i?.code})`)
};

const es_admin_external_booking_edit_order_summary_discount_line = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Discount_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descuento (${i?.code})`)
};

const fr_admin_external_booking_edit_order_summary_discount_line = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Discount_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Réduction (${i?.code})`)
};

const nl_admin_external_booking_edit_order_summary_discount_line = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Discount_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Korting (${i?.code})`)
};

const it_admin_external_booking_edit_order_summary_discount_line = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Discount_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sconto (${i?.code})`)
};

const pt_br2_admin_external_booking_edit_order_summary_discount_line = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Discount_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desconto (${i?.code})`)
};

const pl_admin_external_booking_edit_order_summary_discount_line = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Discount_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zniżka (${i?.code})`)
};

const hu_admin_external_booking_edit_order_summary_discount_line = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Discount_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kedvezmény (${i?.code})`)
};

const ro_admin_external_booking_edit_order_summary_discount_line = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Discount_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reducere (${i?.code})`)
};

/**
* | output |
* | --- |
* | "Discount ({code})" |
*
* @param {Admin_External_Booking_Edit_Order_Summary_Discount_LineInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_order_summary_discount_line = /** @type {((inputs: Admin_External_Booking_Edit_Order_Summary_Discount_LineInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Order_Summary_Discount_LineInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_order_summary_discount_line(inputs)
	if (locale === "de") return de_admin_external_booking_edit_order_summary_discount_line(inputs)
	if (locale === "es") return es_admin_external_booking_edit_order_summary_discount_line(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_order_summary_discount_line(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_order_summary_discount_line(inputs)
	if (locale === "it") return it_admin_external_booking_edit_order_summary_discount_line(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_order_summary_discount_line(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_order_summary_discount_line(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_order_summary_discount_line(inputs)
	return ro_admin_external_booking_edit_order_summary_discount_line(inputs)
});
export { admin_external_booking_edit_order_summary_discount_line as "admin.external_booking_edit.order_summary.discount_line" }